// extracted by mini-css-extract-plugin
module.exports = {"footerActions":"styles_footerActions__GjsYZ","footerDisclaimer":"styles_footerDisclaimer__RAb5J","footer":"styles_footer__nMven"};